import React, { useState } from 'react';
import { Phone, SquarePen, TrashIcon } from 'lucide-react';
import NotificationTemplateForm from 'features/crm/components/notification-templates/NotificationTemplateForm';
import NotificationsList from 'features/crm/components/notifications/NotificationsList';
import DocsList from 'features/docs/components/DocsList';
import { Tabs, Tab } from 'shared/ui/Tabs';
import ClientsList from 'features/parties/components/clients/ClientsList';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { notificationTemplateService } from 'features/crm/api';

const NotificationTemplateItem = ({ item, refreshList }) => {
  const { openModal, closeModal } = useLayout();
  const { currentColor, showToast } = useStateContext();

  const handleEditNotificationTemplate = () => {
      openModal({
        component: <NotificationTemplateForm item={item}/>,
        title: 'Изменить шаблон уведомления',
      });
    };

  const handleDeleteNotificationTemplate = async () => {
    const confirmDelete = window.confirm(`Вы уверены, что хотите удалить шаблон "${item.title}"?`);
    if (confirmDelete) {
      const response = await notificationTemplateService.delete(item.id);
      if(response.status === 0) {
        showToast({
          title: 'Успешно!',
          content: `Шаблон "${item.title}" удален`,
          type: 'success',
        });
        closeModal();
        refreshList ? refreshList() : null;
      }
      else{
        showToast({
          title: 'Ошибка!',
          content: response.message || 'Что-то пошло не так!',
          type: 'error',
        });
      }
    }
  };


  return (
    <>
      {/* Header Section */}
      <div className='flex justify-between items-start mb-6'>
        <div>
          <h1 className='text-xl font-semibold mb-1'>{item.title}</h1> 
          <p className='text-gray-500 text-xs'>Создан {item.created}</p> 
        </div>
        <div className='text-right space-x-2'>
          <button className=' text-white px-4 py-2 rounded-md hover:' style={{ backgroundColor: currentColor }} onClick={() => handleEditNotificationTemplate()}>
            <SquarePen size={16} className='mr-1' /> 
          </button>
          <button className=' text-white px-4 py-2 rounded-md hover: bg-red-500' onClick={() => handleDeleteNotificationTemplate()}>
            <TrashIcon size={16} className='mr-1' />
          </button>
        </div>
      </div>

      <div className='bg-white rounded-lg shadow-sm border mb-6'>
        <div className='p-4 border-b'>
          <h2 className='font-medium text-sm'>СТАТИСТИКА</h2> 
        </div>
        <div className='p-4'>
          <div className='grid grid-cols-2 gap-4'>
            <div className='space-y-4'>
            <div className='flex justify-between border-b border-dotted pb-2'>
                <span className='text-gray-600 text-sm'> Общее кол-во</span>
                <span className='text-sm'>{item.stats?.total}</span> 
              </div>
              <div className='flex justify-between border-b border-dotted pb-2'>
                <span className='text-gray-600 text-sm'> Кол-во отправленных</span>
                <span className='text-sm'>{item.stats?.sent}</span> 
              </div>
              <div className='flex justify-between border-b border-dotted pb-2'>
                <span className='text-gray-600 text-sm'>Кол-во прочитанных</span>
                <span className='text-sm'>{item.stats?.read}</span> 
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Recent Operations Section */}
      <div className='bg-white rounded-lg shadow-sm border'>
        <Tabs initialTab='docs'>
          <Tab key='docs' label='Уведомления'>
            <NotificationsList template={item}/>
          </Tab>
          <Tab key='money' label='Клиенты'>
            <ClientsList targetUrl={item.meta.href + '/clients'} />
          </Tab>
          <Tab key='bonus' label='Документы'>
            <div className='text-center text-gray-500 text-sm py-4'>
              Нет данных об истории бонусов
            </div>
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default NotificationTemplateItem;